import React, { createContext, useContext } from "react";
import { useDownloadCSV, DownloadStatus } from "@src/pages/intelligence-search-v2/hooks/use-download-csv";

type DownloadCSVContextType = {
    status: DownloadStatus;
    error: string | null;
    download: () => Promise<void>;
};

const DownloadCSVContext = createContext({} as DownloadCSVContextType);

export const DownloadCSVProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const value = useDownloadCSV();
    return <DownloadCSVContext.Provider value={value}>{children}</DownloadCSVContext.Provider>;
};

export const useDownloadCSVContext = () => useContext(DownloadCSVContext);
